import type { LinkType } from 'types'
import type { Props } from '.'

export type Raw = {
  acfFcLayout: 'sticky_cta'
  stickyCta: {
    linkCta: {
      headlineText: string
      bodyText: string
      link: LinkType
      secondaryLink?: LinkType
    }
  }
}

export type Parsed = {
  name: 'StickyCTA'
  isFullWidth: boolean
  props: Props
}

export function parser(rawComponent: Raw): Parsed {
  return {
    name: 'StickyCTA',
    isFullWidth: true,
    props: rawComponent.stickyCta.linkCta,
  }
}
